// The Registrar Administrator's Acasă. The wireframe gives this role and the
// Operator the same page, scoped by what each can see — so both render the shared
// composite and differ only in the rail they browse under.
//
// `wireframes/react/src/pages/Acasa.tsx:165`: with more than one location the band
// asks how many of them have reported today, not whether "I" have.
import { ReporterHome } from '../ReporterHome';

export function RegistrarAdminHome(): JSX.Element {
  return <ReporterHome rolePrefix="/registrar-admin" oversees />;
}
